import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function OrderComplete() {
  const { clear } = useCart();
  useEffect(() => {
    document.title = "Thank You · Washington Family Provisions";
    clear();
  }, []);

  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-5 py-32 text-center md:px-8">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-sage text-cream">
        <Check size={30} />
      </div>
      <h1 className="mt-8 font-serif text-5xl text-wood-900">Thank you</h1>
      <p className="mt-4 text-wood-700">
        Your order is complete and confirmed through Square. A receipt and order updates will arrive by email. We'll prepare your provisions with care.
      </p>
      <Link to="/" className="mt-8 rounded-full bg-wood-900 px-8 py-4 text-sm font-medium text-cream transition-colors hover:bg-honey-dark">
        Back to home
      </Link>
    </div>
  );
}
